import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-chooseUs',
  templateUrl: './chooseUs.component.html',
  styleUrls: ['./chooseUs.component.scss']
})
export class ChooseUsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
